export default __webpack_public_path__ + "static/media/edit_info_icon.85441b94.png";